export default {

  items: [
    'BITCOIN',
    'CRYPTO_CURRENCY_OTHER',
    'CRYPTO_CURRENCY_BASKET'
  ]
}
